/* The website review, in the three languages the site publishes.

   The reviewed site's own content - the summary, the findings, the
   recommendations - arrives as data in `report.data` and is written by the agent
   that ran the review, so it is not translated here. What this dictionary holds
   is the page's own chrome and labels: the section heads, the score card labels,
   the table columns and the call to action at the foot of the report.

   The keys are the English strings, the same convention the rest of the site
   uses. `{site}` is the reviewed business (the client), `{date}` and `{count}`
   are the stamped date and the review count. */

export const websiteReportMessages = {
  'en-MY': {
    'Website Review': 'Website Review',
    'Prepared {date}': 'Prepared {date}',
    'Performance (Mobile)': 'Performance (Mobile)',
    'Performance (Desktop)': 'Performance (Desktop)',
    'Accessibility': 'Accessibility',
    'Best Practices': 'Best Practices',
    'Design': 'Design',
    'Summary': 'Summary',
    'Your website today': 'Your website today',
    'Screenshot of {site}': 'Screenshot of {site}',
    'How visible are you on Google?': 'How visible are you on Google?',
    'Google rating:': 'Google rating:',
    '({count} reviews)': '({count} reviews)',
    'Indexed pages:': 'Indexed pages:',
    'Search phrase': 'Search phrase',
    'Your position': 'Your position',
    'Who ranks above you': 'Who ranks above you',
    'Not in top 20': 'Not in top 20',
    'Key findings': 'Key findings',
    'Evidence:': 'Evidence:',
    'What\'s already working': 'What\'s already working',
    'Our recommendations': 'Our recommendations',
    'What {site} could look like': 'What {site} could look like',
    'A redesign concept prepared in your brand colours by our team, so you can visualise exactly what the website could look like before you commit.': 'A redesign concept prepared in your brand colours by our team, so you can visualise exactly what the website could look like before you commit.',
    'Redesign mockup for {site}': 'Redesign mockup for {site}',
    'Ready to improve your online presence?': 'Ready to improve your online presence?',
    'Based on this review, we recommend:': 'Based on this review, we recommend:',
    'We currently have a promotion on web design, SEO, and sponsored ads packages.': 'We currently have a promotion on web design, SEO, and sponsored ads packages.',
    'Email us': 'Email us',
    'WhatsApp': 'WhatsApp',
    'This review was prepared by {site}, a Malaysian web design and digital marketing studio.': 'This review was prepared by {site}, a Malaysian web design and digital marketing studio.',
    'Website Redesign': 'Website Redesign',
    'Advanced SEO': 'Advanced SEO',
    'Sponsored Ads': 'Sponsored Ads'
  },

  'zh-MY': {
    'Website Review': '网站审查报告',
    'Prepared {date}': '准备日期：{date}',
    'Performance (Mobile)': '行动表现（手机）',
    'Performance (Desktop)': '行动表现（电脑）',
    'Accessibility': '无障碍',
    'Best Practices': '最佳实务',
    'Design': '设计',
    'Summary': '摘要',
    'Your website today': '您的网站现况',
    'Screenshot of {site}': '{site} 的截图',
    'How visible are you on Google?': '您在 Google 的曝光如何？',
    'Google rating:': 'Google 评分：',
    '({count} reviews)': '（{count} 则评论）',
    'Indexed pages:': '已收录页面：',
    'Search phrase': '搜索词',
    'Your position': '您的位置',
    'Who ranks above you': '排在前面的对手',
    'Not in top 20': '未进前 20 名',
    'Key findings': '主要发现',
    'Evidence:': '佐证：',
    'What\'s already working': '已经做对的地方',
    'Our recommendations': '我们的建议',
    'What {site} could look like': '{site} 可以变成的样子',
    'A redesign concept prepared in your brand colours by our team, so you can visualise exactly what the website could look like before you commit.': '这是我们团队依您的品牌配色制作的全新改版概念，让您在下决定之前，就能先看到网站可以变成什么样子，而不只是听我们描述，看得见才敢决定。',
    'Redesign mockup for {site}': '{site} 的改版模拟图',
    'Ready to improve your online presence?': '准备好提升您的线上形象了吗？',
    'Based on this review, we recommend:': '根据这份审查，我们建议：',
    'We currently have a promotion on web design, SEO, and sponsored ads packages.': '我们目前有网页设计、SEO 与付费广告配套的优惠。',
    'Email us': '电邮我们',
    'WhatsApp': 'WhatsApp',
    'This review was prepared by {site}, a Malaysian web design and digital marketing studio.': '这份审查由 {site} 准备，一家马来西亚的网页设计与数字营销工作室。',
    'Website Redesign': '网站改版',
    'Advanced SEO': '进阶 SEO',
    'Sponsored Ads': '付费广告'
  },

  'ms-MY': {
    'Website Review': 'Semakan Laman Web',
    'Prepared {date}': 'Disediakan {date}',
    'Performance (Mobile)': 'Prestasi (Mudah Alih)',
    'Performance (Desktop)': 'Prestasi (Desktop)',
    'Accessibility': 'Kebolehcapaian',
    'Best Practices': 'Amalan Terbaik',
    'Design': 'Reka bentuk',
    'Summary': 'Ringkasan',
    'Your website today': 'Laman web anda hari ini',
    'Screenshot of {site}': 'Tangkapan skrin {site}',
    'How visible are you on Google?': 'Sejauh mana anda kelihatan di Google?',
    'Google rating:': 'Penilaian Google:',
    '({count} reviews)': '({count} ulasan)',
    'Indexed pages:': 'Halaman diindeks:',
    'Search phrase': 'Frasa carian',
    'Your position': 'Kedudukan anda',
    'Who ranks above you': 'Siapa di atas anda',
    'Not in top 20': 'Tidak dalam 20 teratas',
    'Key findings': 'Penemuan utama',
    'Evidence:': 'Bukti:',
    'What\'s already working': 'Apa yang sudah berkesan',
    'Our recommendations': 'Cadangan kami',
    'What {site} could look like': 'Rupa {site} yang mungkin',
    'A redesign concept prepared in your brand colours by our team, so you can visualise exactly what the website could look like before you commit.': 'Ini konsep reka bentuk semula yang kami sediakan mengikut warna jenama anda, supaya anda dapat melihat rupa laman web anda sebelum membuat keputusan.',
    'Redesign mockup for {site}': 'Mockup reka bentuk semula untuk {site}',
    'Ready to improve your online presence?': 'Sedia meningkatkan kehadiran dalam talian anda?',
    'Based on this review, we recommend:': 'Berdasarkan semakan ini, kami cadangkan:',
    'We currently have a promotion on web design, SEO, and sponsored ads packages.': 'Kami ada promosi untuk pakej reka bentuk web, SEO dan iklan berbayar buat masa ini.',
    'Email us': 'E-mel kami',
    'WhatsApp': 'WhatsApp',
    'This review was prepared by {site}, a Malaysian web design and digital marketing studio.': 'Semakan ini disediakan oleh {site}, sebuah studio reka bentuk web dan pemasaran digital Malaysia.',
    'Website Redesign': 'Reka Bentuk Semula Web',
    'Advanced SEO': 'SEO Lanjutan',
    'Sponsored Ads': 'Iklan Berbayar'
  }
};
